document.addEventListener('DOMContentLoaded', () => {

    const cover = document.getElementById('cover');
    
    const init = () => {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
        
        setTimeout(() => {
            //document.querySelector('.js-sectionsnav') ? window.sectionNav() : false;
            window.carousels();
            window.anims();
            window.lightboxes();
            cover.remove();
        }, 250);  
        
        window.location.hash ? window.runScroll( window.location.hash ) : false;
    };
    
    window.addEventListener('load', init);

}, false);